export const DATEPICKER_WRAPPER_ID = 'date-picker-wrapper';

export const SCROLL_TO_DATE_DELAY = 500;
export const SCROLL_ANIMATION_DELAY = 50;
export const MAX_RETRIES = 10;

export const INITIAL_SCHEDULE_DAYS = 14;
export const SCHEDULE_LOAD_MORE_DAYS = 5;
export const MAX_SCHEDULE_DAYS_TO_FETCH = 14; // Magicline API limits us to max 14 days;
export const MAX_SCHEDULE_FUTURE_DAYS = 20;

export const SCHEDULE_DATE_FORMAT = 'YYYY-MM-DD';
export const SCHEDULE_TIME_FORMAT = 'HH:mm';
export const SCHEDULE_HOUR_FORMAT = 'HH:00';
export const SCHEDULE_DAY_FORMAT = 'dddd D[th]';
export const SCHEDULE_DAY_DISPLAY_FORMAT = 'dddd Do';

export const SCHEDULE_TIME_SLOTS = 24;

export const DATE_PICKER_DESKTOP_DAYS = 21;
export const DATE_PICKER_MOBILE_DAYS = 14;

export const DAY_SCROLL_OFFSET = 450;

export const FINDACLASS_TRANSLATION_PREFIX = 'findaclass.';
export const FILTER_TRANSLATION_PREFIX = 'filter.';
